// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7d5075bc","404":"9a825add","498":"73eaeeeb","787":"0c95cc4d"}[chunkId] + ".chunk.js";
};